import { defineElement } from '@webtides/element-js';

import BaseMainNavigation from '@zeg/base-light-module/frontend/components/cms-areas/_header/main-navigation/main-navigation.class';

class MainNavigation extends BaseMainNavigation {
    constructor() {
        super();
    }

    determineSubMenuPositions() {
        /**
         * positions the submenus to not leave headers container
         */
        if (!this.offsetParent) {
            return;
        }
        const windowWidth = window.innerWidth;
        this.$firstLevelMenuItems.forEach((menuItem, index) => {
            const menuItemLeft = menuItem.getBoundingClientRect().left;
            const submenu = menuItem.querySelector('[data-submenu]');
            const subMenuWidth = submenu.offsetWidth;

            if (!submenu.classList.contains('is-mega-flyout') && menuItemLeft + subMenuWidth >= windowWidth) {
                //else align right
                const shift = menuItemLeft + subMenuWidth - windowWidth;
                submenu.style.setProperty('--subMenuTransform', `-${shift + 48}px`);
            } else if (!submenu.classList.contains('is-mega-flyout')) {
                submenu.style.removeProperty('--subMenuTransform');
            }
        });
    }
}

defineElement('main-navigation', MainNavigation);
